import { useContext } from 'react'
import { useMutation, MutationFunction } from 'react-query'
import { Languages } from '../../interfaces/common'
import { LocaleContext } from '../../components/LocaleContext/LocaleContext'

export interface IUseMutationHookProps<TProps, TData> {
  path: string
  mutationFn: (url: string, props: TProps, locale: Languages) => Promise<TData>
  onSuccess?: (data: TData) => void
}

export function useMutationHook<TProps, TData>({ path, mutationFn, onSuccess }: IUseMutationHookProps<TProps, TData>) {
  const { locale } = useContext(LocaleContext)

  const mutationFunction: MutationFunction<TData, TProps> = async (body: TProps) => {
    return mutationFn(path, body, locale)
  }

  const { mutateAsync } = useMutation<TData, unknown, TProps>({
    mutationKey: [path],
    mutationFn: mutationFunction,
    onSuccess,
  })

  return async (props: TProps) => mutateAsync(props)
}
